import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=2606f454&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=2606f454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606f454",
  null
  
)

export default component.exports